// extracted by mini-css-extract-plugin
export default {"sectionscontainer":"Sections_sectionscontainer__lBEp5","backtotop":"Sections_backtotop__xV+ci"};